/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const Information = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 20 20">
      <path d="M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C15.514,20 20,15.514 20,10 C20,4.486 15.514,0 10,0 M10,18 C5.589,18 2,14.411 2,10 C2,5.589 5.589,2 10,2 C14.411,2 18,5.589 18,10 C18,14.411 14.411,18 10,18 M11,13 L11,10 C11,9.447 10.552,9 10,9 L9,9 C8.448,9 8,9.447 8,10 C8,10.553 8.448,11 9,11 L9,14 C9,14.553 9.448,15 10,15 L11,15 C11.552,15 12,14.553 12,14 C12,13.447 11.552,13 11,13 M10,7.0996 C10.607,7.0996 11.1,6.6076 11.1,5.9996 C11.1,5.3926 10.607,4.9006 10,4.9006 C9.393,4.9006 8.9,5.3926 8.9,5.9996 C8.9,6.6076 9.393,7.0996 10,7.0996" />
    </BaseSvgIcon>
  )
}

export default Information
